import { NgModule } from "@angular/core";
import { CoreModule } from "@modules/core/core.module";
import { TaxWithheldSummaryUIComponent } from "./tax-withheld-summary.component";
import { TaxOfflineInfoLegacyUIComponent } from "../tax-offline-info-legacy/tax-offline-info-legacy.component";

@NgModule({
	declarations: [TaxWithheldSummaryUIComponent, TaxOfflineInfoLegacyUIComponent],
	imports: [CoreModule],
	exports: [TaxWithheldSummaryUIComponent, TaxOfflineInfoLegacyUIComponent]
})
export class TaxWithheldSummaryUIModule {}
